<img src="assets/img/oh-snap_v2.svg" alt="error-state" />
<p>
  Die Fremdeinschätzung ist anonym.
  <br />
  Bitte <a href="/users/sign_out">logge Dich aus</a> bevor Du eine Fremdeinschätzung abgibst.
</p>
